import React, { useMemo } from 'react'

import {
  AIGeneratedGradientFilled, Button, Icon, Tooltip,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import ArchiveFileModal from 'Pods/Shared/ArchiveFileModal/ArchiveFileModal'

import { EDIT_WITH_AI_LABEL, buildArchiveFileLabels } from './constants'
import useEditWithAi, { buildEditWithAiHref } from './Hooks/useEditWithAi'

const ICON_SIZE = { width: '16', height: '16' }

function EditWithAiAction({
  itemSlug,
  isDisabled = false,
  disabledMessage = '',
  tooltipId = '',
  className = '',
}) {
  const customClass = `edit-with-ai-action ${className}`.trim()
  const {
    candidates, isPreparing, handleClick, handleChoose, handleCloseChoice,
  } = useEditWithAi(itemSlug)
  const archiveFileLabels = useMemo(buildArchiveFileLabels, [])
  const icon = (
    <Icon
      svgComponent={AIGeneratedGradientFilled}
      size={ICON_SIZE}
      className="edit-with-ai-action__icon"
    />
  )

  if (isDisabled) {
    const button = (
      <Button
        type="secondary"
        size="small"
        actionType="button"
        icon={icon}
        customClass={customClass}
        disabled
        aria-disabled
      >
        {EDIT_WITH_AI_LABEL}
      </Button>
    )

    return (
      <Tooltip id={tooltipId} randomizeID content={disabledMessage} place="top">
        {button}
      </Tooltip>
    )
  }

  return (
    <>
      <Button
        type="secondary"
        size="small"
        href={buildEditWithAiHref(itemSlug)}
        icon={icon}
        customClass={customClass}
        title={EDIT_WITH_AI_LABEL}
        aria-busy={isPreparing}
        onClick={handleClick}
      >
        {EDIT_WITH_AI_LABEL}
      </Button>
      {candidates && (
        <ArchiveFileModal
          candidates={candidates}
          labels={archiveFileLabels}
          isSubmitting={isPreparing}
          onSubmit={handleChoose}
          onClose={handleCloseChoice}
        />
      )}
    </>
  )
}

EditWithAiAction.propTypes = {
  itemSlug: string.isRequired,
  isDisabled: bool,
  disabledMessage: string,
  tooltipId: string,
  className: string,
}

export default EditWithAiAction
